import { computed, ref } from "vue";
import Analytics from "src/composables/Analytics";
import { useSessionStorage } from "vue-composable";
import { pricing_api } from "boot/axios";

const { log_event } = Analytics();

const { storage: zip_code } = useSessionStorage('zip_code', null);

const available_tdsps = ref([]);

const { storage: selected_tdsp } = useSessionStorage('selected_tdsp', null);

const loading_tdsps = ref(false);
const show_zip_code_error = ref(false);

const get_tdsps = async function () {
  try {
    const { data } = await pricing_api.get(`${ process.env.VUE_APP_PLANS_SERVICE_URL }/api/tdsps`, {
      responseType: 'json'
    });
    return data;
  }
  catch (err) {
    console.error(err);
  }
}

const search_tdsps = async function ({ duns_number } = {}) {
  try {
    log_event({ name: 'shop_tdsp_search', zip_code: zip_code.value })
    loading_tdsps.value = true;
    selected_tdsp.value = null;
    available_tdsps.value = [];
    if (zip_code.value) {
      const { data } = await pricing_api.get(`${ process.env.VUE_APP_PLANS_SERVICE_URL }/api/tdsps`, {
        params: {
          zip_code: zip_code.value,
          duns_number
        },
        responseType: 'json'
      });
      available_tdsps.value = data;
      if (available_tdsps.value?.length === 1) {
        selected_tdsp.value = available_tdsps.value[0];
      }
      show_zip_code_error.value = available_tdsps.value?.length === 0;
    }
    set_posthog_txu_featureflag_variant();
  }
  catch (err) {
    console.log(err);
  }
  finally {
    loading_tdsps.value = false;
  }
}



const clear_zip_code = function () {
  // zip_code.value = null;
  selected_tdsp.value = null;
  available_tdsps.value = []
}

const get_tdsp_by_id = async function ({ tdsp_duns }) {
  try {
    selected_tdsp.value = null;
    available_tdsps.value = [];
    const { data } = await pricing_api.get(`${ process.env.VUE_APP_PLANS_SERVICE_URL }/api/tdsps/${ tdsp_duns }`, {
      responseType: 'json'
    });
    if (data) {
      selected_tdsp.value = data;
    }
    return data;
  }
  catch (err) {
    console.log(err);
  }
}

const get_tdsp_name_by_duns = function (duns) {
  switch (duns) {
    case '007924772':
      return 'AEP Central';
      break;
    case '007923311':
      return 'AEP North';
      break;
    case '957877905':
      return 'Centerpoint';
      break;
    case '1039940674000':
      return 'Oncor';
      break;
    case '007929441':
      return 'TNMP';
      break;
    case '0582138934100':
      return 'LP & L';
      break;
  }
}

const is_lubbock = computed(() => {
  return selected_tdsp.value?.duns_number === '0582138934100'
})

const supported_duns_numbers = [
  '1039940674000', // Oncor
  '957877905' // Centerpoint
]
const live_link_eligible = computed(() => {
  const { duns_number } = selected_tdsp.value || {}
  return supported_duns_numbers.includes(duns_number)
})

export default () => {

  return {
    show_zip_code_error,
    zip_code,

    available_tdsps,
    selected_tdsp,

    loading_tdsps,
    search_tdsps,

    get_tdsps,
    get_tdsp_by_id,
    get_tdsp_name_by_duns,

    clear_zip_code,
    is_lubbock,
    live_link_eligible
  }
}
